module.exports = __webpack_public_path__ + "static/media/35.99321556.wav";